import registryJson from "../ontology-shard-registry.v1.json";

export type OntologyShardRole =
  | "namespace"
  | "tbox"
  | "shape"
  | "abox"
  | "mixed"
  | "projection"
  | "test";

export type OntologyShardScope = "global" | "domain" | "lane" | "test";
export type OntologyShardConsumer =
  | "validator"
  | "browser"
  | "publisher"
  | "generation"
  | "tests";
export type OntologyShardPublicationPolicy = "cdn" | "internal" | "none";
export type OntologyShardEnforcement =
  | "runtime"
  | "compile"
  | "documentation"
  | "test";
export type OntologyShardValidatorLoad = "shape" | "instance" | "lane" | "none";

export interface OntologyShardRegistryEntry {
  path: string;
  role: OntologyShardRole;
  scope: OntologyShardScope;
  consumers: OntologyShardConsumer[];
  publication: {
    policy: OntologyShardPublicationPolicy;
    layer?: "L3+L4" | "L4" | "L5";
    order?: number;
  };
  enforcement: OntologyShardEnforcement;
  origin: {
    kind: "authored" | "derived";
    derivedFrom?: string[];
  };
  validatorLoad: OntologyShardValidatorLoad;
  loadOrder?: number;
  lane?: string;
}

export interface OntologyShardRegistry {
  schemaVersion: "cogo.ontology-shard-registry.v1";
  fixtureRoot: string;
  shards: OntologyShardRegistryEntry[];
}

export const ONTOLOGY_SHARD_REGISTRY =
  registryJson as unknown as OntologyShardRegistry;

export function getOntologyShardsForConsumer(
  consumer: OntologyShardConsumer,
): OntologyShardRegistryEntry[] {
  return ONTOLOGY_SHARD_REGISTRY.shards.filter((shard) =>
    shard.consumers.includes(consumer),
  );
}
